import { WellDetailsStates } from 'business/models/CustomModels';
import TransformPoints from 'components/plateviewer/well/TransformPoints';
import { DropDetails } from 'components/well/constants';
import { CrystalDrawing, CrystalUpdateDetails, DrawingType } from '../constants';
import { getNewId } from 'utils/Global';
import { getCanvasPointerPosition } from '../utils';
import { useAllSelectedWellDrawingsByType } from 'redux/hooks/well';
import { generateCrystalColorHex } from 'utils/ExperimentUtils';

let crystalDrawing: CrystalUpdateDetails = null;
let isDrawingFirstClick: boolean = false;
const useCrystalCreateHandler = (
  wellDetails: DropDetails | WellDetailsStates,
  regionName: string,
  tpObject: TransformPoints,
  getCrystalName: (index: number) => string = null,
) => {
  const { plateID, wellNum, dropNumber } = wellDetails;
  const allCrystalDrawings = useAllSelectedWellDrawingsByType(
    plateID,
    wellNum,
    dropNumber,
    regionName,
    DrawingType.CRYSTAL,
  ) as CrystalDrawing[];

  const onMouseDown: (e) => { drawing: CrystalUpdateDetails; type: DrawingType } = (
    e,
  ) => {
    const { x, y } = getCanvasPointerPosition(e);
    const _id = getNewId();
    crystalDrawing = {
      id: _id,
      x,
      y,
      locked: false,
      isChecked: false,
      name: getCrystalName
        ? getCrystalName(allCrystalDrawings.length + 1)
        : `${plateID}_${wellNum}_${dropNumber}_Crystal${allCrystalDrawings.length + 1}`,
      color: generateCrystalColorHex(_id),
      zIndex: 0,
      isNewDrawing: true,
    };
    isDrawingFirstClick = true;
    return null;
  };

  const onMouseMove: (e) => {
    drawing: CrystalUpdateDetails;
    type: DrawingType;
    isDrawingFirstClick: boolean;
  } = (e) => {
    if (!tpObject) {
      return;
    }
    const { x, y } = getCanvasPointerPosition(e);
    const width = x - crystalDrawing.x;
    const height = y - crystalDrawing.y;
    const {
      x: dbX,
      y: dbY,
      width: dbWidth,
      height: dbHeight,
    } = tpObject.convertRectangleDrawingForDb(
      crystalDrawing.x,
      crystalDrawing.y,
      width,
      height,
    );
    crystalDrawing = {
      ...crystalDrawing,
      width: width,
      height: height,
      dbX,
      dbY,
      dbWidth,
      dbHeight,
    };
    const drawingData = {
      drawing: crystalDrawing,
      type: DrawingType.CRYSTAL,
      isDrawingFirstClick,
    };
    isDrawingFirstClick = false;
    return drawingData;
  };

  const onMouseUp: (e) => { drawing: CrystalUpdateDetails; type: DrawingType } = (e) => {
    if (!isDrawingFirstClick) {
      return { drawing: crystalDrawing, type: DrawingType.CRYSTAL, isNewDrawing: false };
    }
    isDrawingFirstClick = false;
    return null;
  };
  return { onMouseDown, onMouseMove, onMouseUp };
};

export default useCrystalCreateHandler;
